import { Link } from "react-router-dom";
import { Building2, MapPin, Mail, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { lines } from "@/lib/api";

const Row = ({ icon: Icon, children, id }) => (
  <div className="flex gap-4 items-start" data-testid={`contact-${id}`}>
    <Icon className="h-6 w-6 text-brand shrink-0 mt-0.5" strokeWidth={1.75} />
    <div className="text-charcoal/75 leading-[1.75] break-words">{children}</div>
  </div>
);

export default function Contact() {
  const { content } = useSite();
  const c = content.contact;
  useSeo("contact");
  return (
    <div className="font-arial-all" data-testid="contact-page">
      <section className="bg-charcoal text-white">
        <div className="max-w-[1180px] mx-auto px-6 pt-16 pb-32 sm:pt-20">
          <h1 className="font-bold text-4xl sm:text-5xl" data-testid="contact-title">{c.title}</h1>
          <p className="mt-3 text-white/70">{c.subtitle}</p>
        </div>
      </section>
      <section className="max-w-[900px] mx-auto px-6 -mt-20 pb-20">
        <div className="rounded-2xl bg-white border border-charcoal/10 shadow-sm p-8 sm:p-10" data-testid="contact-card">
          <h2 className="text-2xl sm:text-[1.7rem] text-charcoal">{c.card_title}</h2>
          <div className="mt-7 space-y-6">
            <Row icon={Building2} id="company"><span className="text-charcoal">{c.company}</span></Row>
            <Row icon={MapPin} id="address">
              {lines(c.address).map((l, i) => <div key={i}>{l}</div>)}
              {c.phone && <div>Tel: {c.phone}</div>}
              {c.email && <div>Email: {c.email}</div>}
            </Row>
            <Row icon={Mail} id="email"><a href={`mailto:${c.email}`} className="hover:text-brand break-all">{c.email}</a></Row>
          </div>
          <hr className="my-8 border-charcoal/10" />
          <p className="text-charcoal/75" data-testid="contact-note">{c.note}</p>
          <Link to="/listing-questionnaire" className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white px-6 py-3.5 transition-colors" data-testid="contact-questionnaire-button">
            {c.button}<ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
